
import {
  makeStyles,
} from '@material-ui/core/styles';
const drawerWidth = 256;
let rootColor = '#0055d4';
const fontColor = '#445062';
const hColor = '#344256';
const useStyles = makeStyles((theme) => ({

  main: {
    position: 'relative',
    // marginBottom: '30px',
    padding: '20px',
    // minHeight:'100vh',
    // marginLeft: 'auto',
    // marginRight: 'auto',
    // width: '96%',
    // minWidth:'700px',
    '& .btn-margin-success .closebtn': {
      display: 'none'
    },
    '& .containers': {
      padding: 0,
      width: '100%',
      margin: '20px 0',
      justifyContent: 'space-between',
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '20px 20px',
      '@media (max-width: 800px)': {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
    },
    // '& div[value="EndPoint Info."]': {
    //   '& $ctaNxtPrv':{
    //     // backgroundColor: 'red',  
    //     // position: 'absolute',
    //     top: '40px',
    //     right: '0',
    //     '@media (max-width: 800px)': {
    //       position: 'relative',
    //       // marginBottom: '20px',
    //       top: '0',
    //      },
    //   }
    // },    
    '& div[value="TechPrefix Info."]': {
      '& $ctaNxtPrv':{
        // backgroundColor: 'red',
        position: 'absolute',
        top: '40px',
        right: '0',
        '@media (max-width: 800px)': {
         position: 'relative',
        //  marginBottom: '20px',
         top: '0',
        },
      }
    },

    '& div[value="EndPoint Info."] > div + .containers': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      margin: '0',
    },
    '& div[value="TechPrefix Info."] > div + .containers': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      margin: '0',
    },
    '& div[value="Deal Detail"] > div + .containers': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      overflow:'auto',
    },
    '& div[value="Add AM Information"] > div + .containers': {
      '@media (max-width: 400px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
      },
    },

    '& .MuiSnackbar-root': {
      '& .MuiPaper-root': {
        height: "100%",
        overflow: 'auto',
      },
    },
    '& .MuiTypography-h6': {
      color: hColor,
      fontSize: '20px',
      '@media (max-width: 1280px)': {
        fontSize: '18px',
      },
    },
    '& .MuiSelect-select .MuiBox-root': {
      alignItems: 'center',
      height: '24px',
      overflow: 'hidden',
      overflowY: 'auto',
    },
    '& .MuiChip-root': {
      fontSize: '12px',
      height: '24px',
      backgroundColor: 'rgb(15 15 15 / 8%)',
      borderRadius: '16px',
    },
    '& .MuiPaper-root': {
      // height: 'calc(100vh - 330px)',
      overflow: 'auto',
      overflowY: 'auto',
      // position:'relative',
      '& .MuiTable-root': {

        '& .MuiTableBody-root .MuiTableCell-root': {
          fontSize: '14px',
          fontWeight: '600',
          '@media (max-width: 1440px)': {
            fontSize: '13px',
            fontWeight: '600',
            // color:'#616467',
          },
        },
        '& .MuiTableHead-root': {
          width: '100%',
          maxWidth: '100%',
          height: '53px',
          top: 0,
          '& .MuiTableCell-root': {
            lineHeight: '18px',
          },
        },
      },
    },
  },

  pt: {
    paddingTop: '82px',

    '& .containers': {
      padding: 0,
      width: '100%',
      margin: '20px 0',
      justifyContent: 'space-between',
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '20px 20px',
      '@media (max-width: 800px)': {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
    },
    '& div[value="EndPoint Info."]': {
      '& $ctaNxtPrv':{
        // backgroundColor: 'red',  
        position: 'absolute',
        top: '40px',
        right: '0',
        '@media (max-width: 800px)': {
          position: 'relative',
          // marginBottom: '20px',
          top: '0',
         },
      }
    },    
    '& div[value="TechPrefix Info."]': {
      '& $ctaNxtPrv':{
        // backgroundColor: 'red',
        position: 'absolute',
        top: '40px',
        right: '0',
        '@media (max-width: 800px)': {
         position: 'relative',
        //  marginBottom: '20px',
         top: '0',
        },
      }
    },    
    '& div[value="EndPoint Info."] > div + .containers': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      margin: '0',
      gap: '0px 20px',
    },
    '& div[value="TechPrefix Info."] > div + .containers': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      margin: '0',
    },
    '& div[value="Deal Detail"] > div + .containers': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      overflow:'auto',
      gap: '0px 20px',
    },
    '& div[value="Add AM Information"] > div + .containers': {
      '@media (max-width: 400px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
      },
    }

  },
  delCotnr:{
    '& > div':{
      marginBottom:'20px'
    }
  },
  formTabCard:{
    padding: '15px',
    // color: '#4a4a4a',
    backgroundColor: '#fff',
    borderRadius: '4px',
    marginBottom: '20px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  },
  formTabCard2:{
    padding: '15px',
    // color: '#4a4a4a',
    backgroundColor: '#fff',
    borderRadius: '4px',
    marginBottom: '20px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    '& .containers':{
      display: 'none',
    }
  },
  formTabheading:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', 
    '& .flexIcon':{
      display: 'flex', 
      alignItems: 'center',
      cursor: 'pointer',
    },
    '& h1':{
      color:'#004c8c',
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '0px',
      '@media (max-width: 800px)': {
        fontSize: '16px',
       },
    },
    '& svg':{
      color:'#f69140',
     width: '18px',
      height: '18px',
      marginRight: '10px',
      '@media (max-width: 800px)': {
        width: '16px',
        height: '16px',
       },
    }

  },
  btnsfrm:{
    display: 'flex',
    alignItems: 'center',
    '& button':{
      marginRight:'10px'
    },
    '& button:last-of-type':{
      marginRight:'0px'
    }
  },
  searchForm:{
    // marginTop: '20px',
    // marginBottom: '20px',
  },
  fromBtn:{
    display: 'flex',
    justifyContent: 'flex-end',
    '& .smtbtn':{
      padding: '7px 24px',
      border: 0,
      color: '#fff',
      background: rootColor,
      borderRadius: '4px'
    }
  },
  tableBox: {
    border: '1px solid #d9dfe3',
    borderRadius: '4px',
    padding: '24px 15px',
    minWidth: '700px',
    background: '#f5f9fa',
  },
  Brdcrb: {
    '& span:first-of-type': {
      marginRight: '3px',
    },
    '& span': {
      padding: 0,
      color: '#8a8d8f',
      fontWeight:'500',
    },
    '& svg': {
      marginRight: 0
    },
    '& a:hover': {
      color: '#2da0da',
      textDecoration: 'none',
    },
  },
  breadCrmb: {
    '& li:last-of-type': {
      '& span': {
        color: '#2da0da',
      }
    },
    '& li':{
      fontSize:'16px',
      fontWeight:'500',
    }


  },
  formioClass: {
    '& div': {
      maxWidth: '100%',
    },
  },


 
  //formSection
  marginChange: {
    // marginTop: theme.spacing(30),
    fontSize: '24px',
    fontWeight: '600',
    color: '#475F7B',
    // marginBottom: '20px',
  },

  //header 
  appBar: {
    // fontSize:'1.6rem',
    top: 0,
    display: 'flex',
    minWidth: '740px',
    width: '100%',
    padding: '8px 20px 8px 21px',
    position: 'absolute',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: theme.spacing(8),
    backgroundColor: '#fff',
    borderBottom: '0.3px solid #C5CFD3',
    boxShadow: '0 0 3px #dbdbdb',
    zIndex: '999',
    '& .MuiGrid-container': {
      justifyContent: 'space-between',
    }
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    flex: 1,
    // '&:hover': {
    //   backgroundColor:' #F0F8FA',
    // },
    marginRight: theme.spacing(2),
    marginLeft: '30px',
    width: '100%',
    minWidth: '220px',
    maxWidth: '700px',
    border: '1px solid #C8D8DE',
    borderRadius: theme.spacing(5),
    backgroundColor: '#fff',
    // boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
  },

  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: theme.spacing(2),
    '& svg': {
      fill: '#697381',
    },
  },
  logoSvg: {
    color: '#052656',
    width: '120px',
    '& h2': {
      marginTop: '0px',
      paddingLeft: '15px',
      fontFamily: " Knife Princess",
      fontSize: '26px',
    },
    '& img': {
      width: '100%',
      height: '28px',
    }

  },
  inputRoot: {
    width: '100%',
    height: '48px',
  },
  inputInput: {
    fontSize: '14px',
    padding: theme.spacing(1.5, 8.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(3)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    '&::placeholder': {
      color: fontColor,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  avatar: {
    width: '2.1rem',
    height: '2.1rem',
    borderRadius: '50%',
    border: '1px solid #237DA7',
    backgroundColor: '#fff',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
    }
  },
  avatarBtn: {
    padding: theme.spacing(1, 1, 1, 1),
    marginTop: '-6px',
    borderRadius: theme.spacing(.5),
  },
  btnGrp: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'end',
    '& svg': {
      fill: '#303F53'
    },
    '& .MuiIconButton-root': {
      marginLeft: theme.spacing(2)
    },
  },
  avatarName: {
    fontSize: '14px',
    marginLeft: theme.spacing(1),
  },
  //policy image
  svgimg: {
    width: '375px',
    maxWidth: '375px',
    position: 'fixed',
    marginTop: '75px',
    // marginLeft:drawerWidth,
    textAlign: 'center',
    // paddingTop:'25px',
    // paddingLeft:'30px',
    '@media (max-width: 1600px)': {
      width: '286px',
      marginTop: '24px'
    },
    '@media (max-width: 1280px)': {
      display: 'none',
    },
    '& img': {
      opacity: ".4",
      '@media (max-width: 1600px)': {
        width: '75%',
      },
    },
    '& h6': {
      paddingTop: '16px ',
      fontSize: '16px ',
      color: '#65707F',
      margin: "0px",
      '@media (max-width: 1600px)': {
        fontSize: '15px',
      },
    },
    '& p': {
      fontSize: '14px',
      lineHeight: '24px',
      color: '#949DA7',
      paddingTop: '8px',
      paddingLeft: '18px',
      margin: "0px",
      '@media (max-width: 1600px)': {
        fontSize: '13px',
      },
    },
  },

  sideMenuInactive: {
    width: '0px',
    position: 'fixed',
    '& .MuiDrawer-paper': {
      width: '0px',
    }
  },

  //SideMenu
  sideMenuClose: {
    // display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    zIndex: '998',
    // paddingRight: '2px',
    left: '-3px',
    right: '0px',
    top: '60px',
    width: '256px',
    backgroundColor: '#fff',
    borderRight: '1px solid #e3e0e0',
    display: 'none',
    height: 'calc(100vh - 60px)',
  },
  sideMenuOpen: {
    // display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    zIndex: '998',
    // paddingRight: '2px',
    left: '-3px',
    right: '0px',
    top: '60px',
    width: '256px',
    backgroundColor: '#fff',
    borderRight: '1px solid #e3e0e0',
    display: 'block',
    height: 'calc(100vh - 60px)',
    '@media (min-width: 1201px)': {
      display: 'none',
    },
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  header: {

    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: 'calc(100vh - 180px)',
    '& .MuiPaper-root': {
      width: '252px',
      backgroundColor: 'transparent',
      height: 'calc(100vh - 180px)',
      // marginLeft: '12px',
      borderRight: 'none',
    }
  },
  drawerPaper: {
    width: '226px',
    backgroundColor: 'transparent',
    marginLeft: '12px',
    borderRight: 'none',
    // height:'calc(100vh - 272px)' ,
    // overflowY: 'scroll',
  },
  drawerActive: {
    color: '#2da0da',
  },
  drawerContainer: {
    // overflow: 'auto',
    '& .MuiListItemIcon-root': {
      minWidth: '20px',
      '& svg': {
        width: '12px',
      }
    },
    '& .MuiListItem-gutters': {
      padding: '4px 10px 4px 10px',
      marginBottom: '10px',
    },
    '& .MuiTypography-body1': {
      fontSize: '16px',
      // fontWeight: '500',
      //   '&:hover ':{
      //   color:'#2da0da',
      // } 
    },
    '& .MuiCollapse-root':{
      '& .MuiButtonBase-root':{
         paddingLeft:'20px',
         border:'none !important',
      },
    },
    // '& .MuiButtonBase-root':{
    //   '&:hover .MuiTypography-body1':{
    //     color:'#2da0da',
    //   }, 
    //   '&:hover div svg':{

    //       fill:'#2da0da',

    //   } ,
    //   '&:hover':{
    //     borderLeft:"4px solid #2da0da",
    //     transition:"0.2s"
    //   } 
    // },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  menuHead: {
    padding: '27px 0px 5px 24px',
  },
  ftrlgo: {
    '& img': {
      width: '220px',
    }
  },
  drawerFooter: {
    fontSize: '10px',
    color: '#8796a5',
    padding: theme.spacing(1, 0, 1, 0),
  },
  menuFont: {
    fontSize: 5,
    fontWeight: 200,
    color: fontColor,
    // backgroundColor:'green'
    '& .MuiListItem-button:hover': {
      background: '#fafafa',
    }
  },
  activeMenu: {
    // backgroundColor:'red',
    '& .MuiTypography-body1': {
      color: rootColor,
    },
    '& div svg': {
      fill: rootColor,
    },
    borderRight:`4px solid ${rootColor} !important`,
    transition: "0.2s",
    background: '#fafafa !important',
    // paddingLeft: '21px !important',
  },
  //Subheader
  appSubBar: {
   padding:'0 20px',
    marginTop: '80px',
  },
  shh: {
    paddingTop: '16px',
    // flex:'0 0 100%',
    minWidth: '700px',
  },
  topSp: {
    padding: '15px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    borderRadius: '4px',
    '& > .MuiGrid-root > .MuiGrid-root': {
      minWidth: '700px',
    },
    '& > .MuiGrid-container': {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: 'auto',
      paddingLeft: '20px',
      paddingRight: '20px',
      '& ol': {
        flex: '0 0 100%',
        maxWidth: '100%',
        justifyContent: 'flex-start',
      },
      '& > .MuiGrid-container': {
        paddingTop: theme.spacing(3),
        alignItems: 'center',
        flex: '0 0 100%',
        maxWidth: '100%',
        flexWrap: 'nowrap',
        minWidth: '700px',
      },
    },
  },
  rightMr: {
    marginRight: theme.spacing(5),
  },
  menuList: {
    margigRight: '8px',
    color: '#75ADC7',
  },
  heading: {
    fontSize: '24px',
    color: hColor,
    fontWeight: '500',
    marginBottom: 0,
    '@media (max-width: 1280px)': {
      fontSize: '24px',
    },
  },
  flex: {
    marginLeft: drawerWidth,
    display: 'flex',
  },
  flowHeader:{
    display:'flex',
    justifyContent:'space-between',
    marginBottom:'10px',
    '& h2':{
      color:'#363636',
      fontSize: '1.5rem'
    }
  },
  filtersearch:{
    maxWidth:'350px',
    position:'relative',
    display:'flex',
    borderBottom:'2px solid #767676',
    '@media (max-width: 400px)': {
      width:'100%',
    },

  },
  filtersearch_2:{
    maxWidth:'350px',
    position:'relative',
    display:'flex',
    height: '50px',
    alignItems: 'end',
   '& .MuiInputAdornment-root':{
    '& svg':{
      fontSize:'20px',
    },
   },
    // borderBottom:'2px solid #767676',
    '@media (max-width: 400px)': {
      width:'100%',
    },

  },
  totalChep:{
    display: "flex",
  fontSize: "12px",
  fontWeight: 600,
  border: "2px solid",
  borderRadius: "25px",
  padding: "8px",
  alignItems: "center",
  justifyContent: "center",
  color: '#0055d4',
  },
  invFinBtn:{
    border: 0,
    background: '#0000008a',
    borderRadius: '25px',
    whiteSpace: 'nowrap',
    padding: '5px 10px',
    fontSize: '12px',
    color: '#fff'
  },
  searchbtn:{
    color: '#fff',
    padding: '10px 12px',
    fontSize: '14px',
    position: 'absolute',
    top: 0,
    right: 0,
    background: rootColor,
    border: `1px solid ${rootColor}`,
    borderRadius: '0 4px 4px 0',
  },
  searchInput:{
    fontSize: '14px',
    padding: '10px 10px',
    border: 'none',
    background: 'transparent',
    // borderRadius:' 4px',
   
    width:'100%',
    '&:focus':{
      // outline: `1px solid ${rootColor}`
      outline: 'none',
    }
  },
  subBtn: {
    backgroundColor: rootColor,
    color: '#fff',
    height: '36px',
    fontSize: '14px',
    padding: '7px 24px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    border:  `2px solid ${rootColor}`,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all .3s',
    // '&:hover': {
    //   border: '2px solid #0055d4',
    //   color: '#0055d4',
    //   backgroundColor: '#e6effc',
    //   transform: 'translateY(-1px)'
    // },
    '& svg': {
      marginRight: '10px',
      fontSize: '22px',
    },
  },
  loading08: {
    fontSize: '14px',
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 500,
  textAlign: "center",
    '& span': {
      display: 'inline-block',
      position: 'relative',
      color: 'rgba(0, 0, 0, 0.2)',
      animation: '$loading08-parent 5s infinite',
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        content: 'attr(data-text)',
        color: '#fff',
        opacity: 0,
        animation: '$loading08-child 5s infinite',
      },
    },
  },
  '@keyframes loading08-parent': {
    '0%, 35%, 100%': {
      color: 'rgba(0, 0, 0, 0.2)',
    },
    '60%, 80%': {
      color: '#fff',
    },
  },
  '@keyframes loading08-child': {
    '0%': {
      opacity: 1,
    },
    '25%, 100%': {
      opacity: 0,
    },
  },
  loading07: {
    fontSize: '14px',
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 500,
  textAlign: "center",
    '& span': {
      display: 'inline-block',
      position: 'relative',
      color: 'rgba(0, 0, 0, 0.2)',
      animation: '$loading07-parent 5s infinite',
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        content: 'attr(data-text)',
        color: '#0055d4',
        opacity: 0,
        animation: '$loading07-child 5s infinite',
      },
    },
  },
  '@keyframes loading07-parent': {
    '0%, 35%, 100%': {
      color: 'rgba(0, 0, 0, 0.2)',
    },
    '60%, 80%': {
      color: '#0055d4',
    },
  },
  '@keyframes loading07-child': {
    '0%': {
      opacity: 1,
    },
    '25%, 100%': {
      opacity: 0,
    },
  },
  addBtn:{
    backgroundColor: rootColor,
    color: '#fff',
    height: '36px',
    fontSize: '14px',
    padding: '7px 24px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    border:  `2px solid ${rootColor}`,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all .3s',
    position:'absolute',
  },
 
  center: {
    //  marginLeft:theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btn: {
    backgroundColor: '#26AD8D',
    color: '#F2F8FA',
    fontSize: '14px',
    padding: '3px 24px',
    borderRadius: '24px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #187e66',
    cursor: 'pointer',
  },

  errorCard:{
    background:'#f0d5d5',
    display: 'flex',
    width: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
    // position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: '100px auto',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
     border:'2px dashed red',
    borderRadius:'4px',
    '& svg':{
      marginLeft: '20px',
      color: '#757a75',
      fontSize: '30px',
    }
  },
  //Tabes
  formtab: {
    // borderBottom: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.12)',

    borderBottom: '1px solid #A0AFB2',
  },
  topSpace: {
    '& .css-19kzrtu': {
      padding: '0px',
    },
    '& .MuiTab-root': {
      padding: '0px',
      marginRight: '6%',
      width: ' 14%',
      maxWidth: '14%'

    },
    '& .MuiTab-root:last-of-type': {
      marginRight: '0',
    },
    '& [class *="MuiButtonBase-root"].Mui-selected': {
      paddingLeft: '0px',
      fontWeight: 'bold',
      color: '#000',
    },
    '& .MuiTabs-indicator': {
      left: '15px',
      backgroundColor: '#26ad8d',
      width: '130px',
    },
    '& .containers': {
      padding: 0,
      width: '100%',
      margin: '20px 0',
      justifyContent: 'space-between',
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '20px 20px',
      // display: 'grid',
      // gridTemplateColumns: 'auto auto',
      '@media (max-width: 800px)' : {
        gridTemplateColumns: 'repeat(2, 1fr)',
        },
    }
  },
  topSpace_2: {
    '& .css-19kzrtu': {
      padding: '0px',
    },
    '& .MuiTab-root': {
      padding: '0px',
      marginRight: '6%',
      width: ' 14%',
      maxWidth: '14%'

    },
    '& .MuiTab-root:last-of-type': {
      marginRight: '0',
    },
    '& [class *="MuiButtonBase-root"].Mui-selected': {
      paddingLeft: '0px',
      fontWeight: 'bold',
      color: '#000',
    },
    '& .MuiTabs-indicator': {
      left: '15px',
      backgroundColor: '#26ad8d',
      width: '130px',
    },
    '& .containers': {
      padding: 0,
      width: '100%',
      margin: '20px 0',
      justifyContent: 'space-between',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '20px 20px',
      '@media (max-width: 800px)' : {
        gridTemplateColumns: 'repeat(2, 1fr)',
        },
    }
  },

  alertFlow : {
    '& .css-19kzrtu': {
      padding: '0px',
    },
    '& .MuiTab-root': {
      padding: '0px',
      marginRight: '6%',
      width: ' 14%',
      maxWidth: '14%'

    },
    '& .MuiTab-root:last-of-type': {
      marginRight: '0',
    },
    '& [class *="MuiButtonBase-root"].Mui-selected': {
      paddingLeft: '0px',
      fontWeight: 'bold',
      color: '#000',
    },
    '& .MuiTabs-indicator': {
      left: '15px',
      backgroundColor: '#26ad8d',
      width: '130px',
    },
    '& .containers': {
      padding: 0,
      width: '100%',
      margin: '20px 0',
      justifyContent: 'space-between',
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '20px 20px',
      // display: 'grid',
      // gridTemplateColumns: 'auto auto',
      '@media (max-width: 800px)' : {
        gridTemplateColumns: 'repeat(2, 1fr)',
        },
    }
  },

  //   formAline:{
  //     marginLeft:leftGap,
  //     '@media (max-width: 1600px)' : {
  //       marginLeft: '326px'
  //   },
  //   '@media (max-width: 1280px)' : {
  //     marginLeft: '24px'
  // },
  //   },
  steps: {
    width: '100%',
    marginTop: '30px',
    "& .MuiStep-root": {
      transform: 'translateX(-21%)',

    },
    '& .MuiStepper-root': {
      marginBottom: '30px',
    },
    '& .MuiStepConnector-root span': {
      borderTopWidth: '2px',
      borderColor: '#e1e5e6',
    },
    '& .MuiStepLabel-iconContainer svg': {
      height: '32px',
      width: '32px',
      fill: '#d7dbe4',
      stroke: '1px red',
      marginTop: '-4px',
      '&.Mui-active': {
        fill: '#c79f2f',
      },
      '&.Mui-completed': {
        fill: '#26ad8d',
      },
    },
    '& .MuiStepLabel-labelContainer': {
      maxWidth: '112px',
      '& .MuiStepLabel-label': {
        fontWeight: '600',
        '& span': {
          fontSize: '12px',
          color: '#05152D',
          opacity: '.6',
          display: 'block',
          textAlign: 'center',
        },
      }
    },
  },
  //MainSection
  MainSection: {
    marginBottom: '52px',
    width: '100%',
    // marginTop: '45px',
    marginLeft: 'auto',
    // '@media (max-width: 800px)': {
    //   width: `calc(100% - 252px)`,
    // },
  },

  popupCreate: {
    '& div .MuiPaper-root': {
      margin: 'auto',
      borderRadius: '10px',
      padding: '20px',
      width: '800px',
      height: '100%',
      maxHeight: 'calc( 100% - 10%)',
      minWidth: '800px',
    },
  },
  errorpopup:{
    '& .MuiAlert-standardSuccess':{
      backgroundColor:'rgb(237, 247, 237)',
    },
    '& .MuiAlert-standardError':{
      backgroundColor: 'rgb(253, 237, 237)',
    },
    '& .MuiPaper-root': {
      padding: '6px 16px !important',
      width: '100% !important',
      minWidth: '300px !important',
    },
  },
  popupEdit: {
    '& > .MuiDialog-container > .MuiPaper-root': {
      margin: 'auto',
      borderRadius: '10px',
      padding: '0 20px 20px 20px',
      // padding: '0px 6%',
      // width: '800px',
      height: '100%',
      maxHeight: 'calc( 100% - 10%)',
      minWidth: '800px',
    },
  },
  popupcrt: {
    '& div .MuiPaper-root': {
      margin: 'auto',
      borderRadius: '10px',
      // padding: '20px',
      // padding: '0px 6%',
      width: '400px',
      height: '100%',
      maxHeight: 'calc( 100% - 50%)',
      minWidth: '400px',
    },
  },
  poup: {
    ' & .MuiPaper-root': {
      maxHeight: 'calc(100% - 10%)',
      minWidth: '600px',
      minHeight: '300px',
      margin: 'auto',
      borderRadius: '10px',
      padding: '20px',
      width: 'auto',
    },
  },
  from1: {
      maxHeight: 'calc(100% - 10%)',
      // minWidth: '400px',
      minHeight: '300px',
      // margin: 'auto',
      borderRadius: '10px',
      padding: '20px',
      width: '800px',
      '& .containers':{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px',
      }
  },
  war: {
    '& p': {
      fontSize: '15px',
      color: '#ff0000',
      fontWeight: '500',
    },
  },
  loader: {
    width: '48px',
    height: '48px',
    // position: 'absolute',
    marginBottom:'30px',
    marginTop:'30px',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto'
  },
  noData:{
    display: 'flex',
    minWidth: '100px',
    maxWidth: '350px',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    height: '100px',
    // position: 'absolute',
    marginBottom:'30px',
    marginTop:'30px',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    border:'2px dashed gray',
    color:'gray',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    borderRadius:'4px',
    '& p':{
      margin: 0,
    }
  },
  loading: {
    textAlign: 'center',
    paddingTop: '24px',
    '& img': {
      width: '48px',
      height: '48px',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto'
    },
    '& .MuiSvgIcon-root': {
      right: '20px',
      position: 'absolute',
      color: '#d12469',
      fontSize: '32px',
      top: '10px',
      '&:hover': {
        boxShadow: '0px 6px 14px rgba(50, 55, 56, 0.4)',
        borderRadius: '25%'
      }
    },
  },
  bdr: {
    '& h4': {
      fontWeight: '400',
      color: hColor,
    },
    borderBottom: '2px solid #e7ebf1',
    marginBottom: '20px',
  },
  dellabel: {
    '& .makeStyles-inputroot': {
      marginBottom: '40px',
    },
    display: 'flex',
    border: '1px solid #A0AFB2',
    padding: '10px 5px',
    borderRadius: '25px',
    backgroundColor: '#F2F8FA',
    marginBottom: '25px',
  },
  flx: {
    flex: '1',
    paddingLeft: '30px',
    borderRight: '1px solid #A0AFB2',
  },
  flx2: {
    flex: '1',
    paddingLeft: '30px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '450px',
  },
  tps: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: '20px',

    '& Button': {
      color: "#fff",
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      marginLeft: '10px',
      borderRadius: '4px',
      border: '1px solid #98A3A3',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    },
    '& Button:not(:first-of-type)': {
      marginLeft: '10px',
      backgroundColor: '#26AD8D',
      minWidth: '116px',
      '&:hover': {
        backgroundColor: '#26AD8D',
      }
    }
  },
  deleteBtn: {
    display:'flex',
    justifyContent:'end',
    marginTop:'30px',
    '& Button': {
      color: "#fff",
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      // marginLeft: '10px',
      borderRadius: '4px',
      border: '1px solid #98A3A3',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    },
    '& Button:not(:first-of-type)': {
      marginLeft: '10px',
      backgroundColor: '#D12469',
      minWidth: '116px',
      '&:hover': {
        backgroundColor: '#D12469',
      }
    }
  },
  rejApr: {
    display:'flex',
    justifyContent:'end',
    marginTop:'30px',
    '& Button': {
      color: "#fff",
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      // marginLeft: '10px',
      borderRadius: '4px',
      border: '1px solid #D12469',
      boxShadow: 'none',
      backgroundColor: '#D12469',
      '&:hover': {
        backgroundColor: '#D12469',
        boxShadow: 'none',
      }
    },
    '& Button:not(:first-of-type)': {
      marginLeft: '10px',
      border: '1px solid #26AD8D',
      backgroundColor: '#26AD8D',
      minWidth: '116px',
      '&:hover': {
        backgroundColor: '#26AD8D',
      }
    }
  },
  dealBtn: {
    marginBottom:'30px',
    bottom: 0,
    right: '20px',
    position:'absolute',
    '& Button': {
      color: "#fff",
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      // marginLeft: '10px',
      borderRadius: '4px',
      border: '1px solid #98A3A3',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    },
    '& Button:not(:first-of-type)': {
      marginLeft: '10px',
      backgroundColor: '#D12469',
      minWidth: '116px',
      '&:hover': {
        backgroundColor: '#D12469',
      }
    }
  },
  from1Btn: {
    marginTop:'30px',
    display:'flex',
    justifyContent: 'end',
    alineItem:'center',
   
    '& Button': {
      color: "#fff",
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      // marginLeft: '10px',
      borderRadius: '4px',
      border: '1px solid #98A3A3',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    },
    '& Button:not(:first-of-type)': {
      marginLeft: '10px',
      backgroundColor: '#D12469',
      minWidth: '116px',
      '&:hover': {
        backgroundColor: '#D12469',
      }
    }
  },
  tpbp: {
    padding: '20px 22% 6% 6%',
    '& Button': {
      color: "#fff",
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      marginLeft: '10px',
      borderRadius: '4px',
      border: '1px solid #6c757d',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    },
    '& Button:nth-of-type(2)': {
      marginLeft: '10px',
      backgroundColor: '#d12469',
      '&:hover': {
        backgroundColor: '#d12469',
      }
    },
    '& Button:last-of-type': {
      marginLeft: '10px',
      backgroundColor: '#26AD8D',
      '&:hover': {
        backgroundColor: '#26AD8D',
      }
    }
  },
  tpbps: {
    padding: '20px 22% 6% 6%',
    '& Button': {
      color: "#fff",
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      marginLeft: '10px',
      borderRadius: '4px',
      border: '1px solid #6c757d',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    }
  },
  cbtp: {
    margin: '10% 31% 0% 33%',
    '& Button': {
      border: '1px solid #6c757d',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    },
    '& Button:not(:first-of-type)': {
      marginLeft: '10px',
      backgroundColor: '#84AABC',
      '&:hover': {
        backgroundColor: '#84AABC',
      }
    },
    '& Button:last-child': {
      marginLeft: '10px',
      backgroundColor: '#1E6DAA',
      '&:hover': {
        backgroundColor: '#1E6DAA',
      }
    }
  },
  btnAline: {
    // padding:'20px 22% 0px 21%', 
    '& Button': {
      border: '1px solid #6c757d',
      boxShadow: 'none',
      backgroundColor: '#98A3A3',
      '&:hover': {
        backgroundColor: '#98A3A3',
        boxShadow: 'none',
      }
    },
    '& Button:not(:first-of-type)': {
      marginLeft: '100px',
      backgroundColor: '#1E6DAA',
      '&:hover': {
        backgroundColor: '#1E6DAA',
      }
    }
  },

  btnRset: {
    backgroundColor: '#8AA6A5',
    borderColor: '#8AA6A5',
    '&:hover': {
      backgroundColor: '#8AA6A5',
      borderColor: '#8AA6A5',
    }
  },
  btnDflt: {
    backgroundColor: '#1E6DAA',
    borderColor: '#1E6DAA',
    '&:active': {
      backgroundColor: '#195685',
      borderColor: '#195685',
    }
  },
  btnGen: {
    backgroundColor: '#f7a15c',
    borderColor: '#f7a15c',
    '&:hover': {
      backgroundColor: '#f7a15c',
      borderColor: '#f7a15c',
    }
  },
  btnBck: {
    backgroundColor: '#8AA6A5',
    borderColor: '#8AA6A5',
    '&:active': {
      backgroundColor: '#6A8281',
      borderColor: '#6A8281',
    }
  },
  btnSnD: {
    backgroundColor: '#82A9BB',
    borderColor: '#82A9BB',
    '&:active': {
      backgroundColor: '#6C29A3',
      borderColor: '#6C29A3',
    }
  },
  btnDelt: {
    backgroundColor: '#d12469',
    borderColor: '#d12469',
    '&:active': {
      backgroundColor: '#d12469',
      borderColor: '#d12469',
    }
  },
  btnSmt: {
    backgroundColor: rootColor,
    borderColor: rootColor,
    '&:hover': {
      backgroundColor: rootColor,
      borderColor: rootColor,
    }
  },

  ctaNxtPrv: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    maxWidth: '100%',
    '& Button': {
        marginLeft: '10px',
        border: '0',
        borderRadius: '4px',
        padding: '7px 24px',
        fontSize: '14px',
        fontWeight: '500',
        color: '#fff',
        '&:disabled': {
            opacity: '0.5', // Example style for a disabled button
            cursor: 'not-allowed' // Example cursor style for a disabled button
        }
    }
},

  flex3: {
    display: 'flex',
    listStyleType: 'none',
    padding: '0px',
    '& li': {
      paddingRight: '180px',
      fontSize: '14px',
      fontWeight: '600',
      color: '#05152D',
    },
    '& li:nth-child(even)': {
      fontSize: '14px',
      fontWeight: '1000',
      color: 'black',
    }
  },
  preview: {
    '& .MuiChip-root': {
      fontSize: '12px',
      height: '24px',
    },
    '& .map-grid': {
      width: '100%',
      margin: '86px 0 30px',
      justifyContent: 'space-between',
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '30px 20px',
    },
    '& .MuiSelect-select .MuiBox-root': {
      alignItems: 'center',
      height: '24px',
      overflow: 'hidden',
      overflowY: 'auto',
    },
    '& .btn-margin-success .viewbtn': {
      display: 'none'
    },
    // '& .css-19kzrtu': {
    //   padding: '65px 0px 0px',
    // },
    '& [class *="MuiButtonBase-root"].Mui-selected': {
      paddingLeft: '0px',
      fontWeight: 'bold',
      color: '#000',
    },
    '& .MuiTabs-indicator': {
      left: '15px',
      backgroundColor: '#26ad8d',
      width: '130px',
    },
    '& .MuiTab-root': {
      padding: '0px',
      marginRight: '6%',
      width: ' 14%',
      maxWidth: '14%',

    },
    '& [class ^="makeStyles-formtab"]': {
      // '& + div':{
      //   paddingTop:'64px',
      // },

      position: 'fixed',
      background: '#fff',
      zIndex: 4,
      minWidth: '700px',

    },
    '& form': {
      marginLeft: "0px",
    },
    '& .steps': {
      marginLeft: "0px",
    },
    // padding: '34px 10% 0',
    maxWidth: '1280px',
    zIndex: '1',
    backgroundColor: '#fff',
    '& h4': {
      fontWeight: '400',
      color: hColor,

    },
  },
  pt105: {
    paddingTop: '80px',
    '& .containers': {
      padding: 0,
      width: '100%',
      margin: '20px 0',
      justifyContent: 'space-between',
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: 'repeat(1, 1fr)',
      gap: '30px 20px',
    },

  },
  warningSvg: {
    display: 'flex',
    marginBottom: '32px',
    fontSize: '14px',
    color: '#6e747d',
    '& svg': {
      color: '#d12469',
      fontSize: '24px',
      marginRight: '6px',
    }
  },
  warningError: {
    display: 'flex',
    fontSize: '14px',
    marginBottom: '32px',
    color: '#d12469',
    '& svg': {
      color: '#d12469',
      fontSize: '24px',
      marginRight: '6px',
    }
  },
  close: {
    width: '796px',
    padding: '34px 0 20px 20px',
    zIndex: '3',
    position: 'fixed',
    backgroundColor: '#fff',
    right: '0',
    left: '0',
    margin: '0 auto',
    height: '80px',
    transform: 'translateY(0px)',
    borderRadius: '8px 8px 0 0',
    '& h4':{
      fontSize: '24px',
      fontWeight: '600',
      color: '#475F7B',
      // marginBottom: '0px',
    },
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      right: '15px',
      top: '15px',
      color: '#d12469',
      fontSize: '32px',
      '&:hover': {
        boxShadow: '0px 6px 14px rgba(50, 55, 56, 0.4)',
        borderRadius: '25%'
      }
    }
  },
  detailsPopup:{
    position: 'relative',
    maxWidth: '100%',
    // height: '100%',
    boxSizing: 'border-box'
  },
  slctVndr:{
    position: 'relative',
    maxWidth: '100%',
    height: '100%',
    boxSizing: 'border-box'
  },
  headerSticky: {
    width: '100%',
    padding: '20px 0 10px',
    zIndex: '3',
    position: 'sticky',
    backgroundColor: '#fff',
    top: '0',
    transform: 'translateY(0px)',
    borderRadius: '8px 8px 0 0',
    borderBottom: '2px solid #e0e0e0',
    '& h4':{
      fontSize: '24px',
      fontWeight: '600',
      color: '#475F7B',
      marginBottom: '0px',
    },
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      right: '0px',
      color: '#d12469',
      fontSize: '32px',
      '&:hover': {
        boxShadow: '0px 6px 14px rgba(50, 55, 56, 0.4)',
        borderRadius: '25%'
      }
    }
  },
  closeFix: {
      width:'100%',
      display: 'flex',
      justifyContent: 'space-between',
      background: '#fff',
      padding: '20px 0 4px 0',
      borderBottom: '2px solid #c5bdbd',
    '& h4':{
      fontSize: '24px',
      fontWeight: '600',
      color: '#475F7B',
      marginBottom: '0px',
    },
    '& .MuiSvgIcon-root': {
      color: '#d12469',
      fontSize: '32px',
      '&:hover': {
        boxShadow: '0px 6px 14px rgba(50, 55, 56, 0.4)',
        borderRadius: '25%'
      }
    }
  },
  ErhMapLbl:{
    marginBottom:0,
    marginTop:'10px',
    '& li':{
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      color: '#545050',
      padding: '10px 10px',
      // borderBottom: '2px solid #c5bdbd',
    },
    '& span':{
      // marginLeft: '10px',
      flex:'1 0 20%',
      fontSize: '16px',
      color: '#8d8585',
    },
    '& span:not(:first-of-type)':{
      flex:'1 0 80%',
      fontWeight:500
    }
    // '& span':{
    //   marginLeft: '10px',
    //   fontSize: '14px',
    //   color: '#8d8585',
    // }
  },
  closeup: {
    // width: '600px',
    // padding: '20px',
    // minWidth: '600px',
    maxHeight: 'calc(100% - 10%)',
    zIndex: '3',
    // position: 'fixed',
    backgroundColor: '#fff',
    left: '0',
    right: '0',
    // margin: '0 auto',
    // height: '80px',
    // transform: 'translateY(0px)',
    borderRadius: '8px',
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      right: '15px',
      top: '15px',
      color: '#d12469',
      fontSize: '32px',
      '&:hover': {
        boxShadow: '0px 6px 14px rgba(50, 55, 56, 0.4)',
        borderRadius: '25%'
      }
    }
  },
  prvw: {
    padding: '72px 20px 20px',
    '& ul': {
      // marginLeft: '32px',s
      maxWidth: '960px',
    },
    '& ul li': {
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #e5e5e5',
      padding: '24px 0% 0',
    },
    '& ul li span': {
      flex: '1 0 50%',
      fontSize: '16px',
      paddingBottom: '12px',
    },
    '& ul li span:not(:first-of-type)': {
      fontWeight: '500',
      flex: '0 0 50%',
    }
  },
  formData: {
    '& ul li': {
      alignItems: 'center',
      borderBottom: '0px solid #e5e5e5',
      padding: '0',
    },
  },
  tableLoader: {
    // borderTop: '2px solid #e5e5e5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  fileSection:{
    display: 'flex',
    border:'1px solid gray',
    borderRadius:'25px',
    padding:'4px',
  '& .fileTypeBtn': {
    display: 'flex',
    justifyContent: 'end',
    position: 'relative',
    height: '40px',
    // width: '40px',
    transition: 'width 1s ease',
// '&:hover':{
//   width:'160px'
// },
    '& .btntrf': {
      opacity:0,
      position:'absolute',
      transition: 'all 0.5s ease',
    },
    '& .btntrs': {
      // position: 'relative',
      opacity:1,
    },
    '& .MuiButtonBase-root': {
     padding:'8px'
    },
}, 
    // '& .clicked':{
    //   width: '160px',
    // }
    '& .MuiButtonBase-root': {
      padding:'8px'
     },
  },
  btnEnd:{
    display: 'flex',
    justifyContent: 'end',
    marginTop: '20px',
    '& Button': {
      marginLeft: '10px',
      border: '0',
      borderRadius: '4px',
      padding: '6px 14px',
      fontSize: '14px',
      fontWeight: '600',
      color: '#fff'
    }
  },
  btnHeader:{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    marginBottom:'20px',
    '& h1':{
      color:'#004c8c',
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '0px',
      '@media (max-width: 800px)': {
        fontSize: '16px',
       },
    },
  },
  subtable:{
    borderCollapse: 'collapse',
    width: '100%',
    tableLayout: 'fixed',
    '& table':{
      border: '1px solid #c5cfd3',
      width:'100%',
    },
    '& .switch .MuiButtonBase-root':{
      position:'absolute',
      padding:'9px',
      top:0,
      left:0,
      color:'#fff'
    },
    '& .switch .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked':{
      color:'#1976d2'
    },
    '& .mb':{
      marginBottom:'20px'
    },
    '& th':{
      fontWeight: '600',
      width:'100px',
      minWidth:'80px',
      fontSize: '12px',
      border: '1px solid #c5cfd3',
      backgroundColor: '#e3e6e8',
      padding: '8px',
      textAlign: 'center',
      wordWrap: 'break-word',
      '@media (max-width: 800px)': {
        fontSize: '10px',
        padding: '4px',
      },
      '@media (max-width: 400px)': {
        fontSize: '8px',
        wordWrap: 'break-word',
      },

    },
    '& .noBorder td':{
      border: '0',
      backgroundColor: '#e3e6e8',
    },
    '& td':{
      fontSize: '12px',
      border: '1px solid #c5cfd3',
      padding: '4px',
      background: '#fff',
      textAlign: 'center',
      wordWrap: 'break-word',
      '& svg':{
        fontSize: '18px',
      },
      // '& input[type=""]':{
      //   margin: '0',
      //   width: '20px',
      //   height: '20px',
      //   marginTop: '6px',
      //   '@media (max-width: 400px)': {
      //     width: '12px',
      //     height: '12px',
      //   },
      // },
      '& input[type="text"]':{
        width:'100%',
        // padding:'5px',
        '&:focus':{
          outline:'0'
        }
      },
      '& input[type="number"]':{
        width:'100%',
        padding:'5px',
        '&:focus':{
          outline:'0'
        }
      },
      '& button':{
        border:'0',
        background:'#fff'
      },
      '& button:hover':{
        color: '#fa1200',
      },
      '& .deleteBtn':{
        cursor:'pointer',
        border: '1px solid',
        padding: '4px 12px',
        borderRadius: '4px',
        '&:hover':{
          color: '#d12469',
          boxShadow:'0 0 5px #d12469'
        },
        '@media (max-width: 600px)': {
          fontSize: '9px',
          padding: '3px 6px',
          fontWeight:'600',
        },
      },
      '@media (max-width: 800px)': {
        fontSize: '10px',
        padding: '4px',
      },

    }
  },
 //table action button
 atnBtn:{
  border:`2px solid ${rootColor}`,
  padding:'4px 8px',
  color:rootColor,
  fontSize:'10px',
  fontWeight:600,
  borderRadius:'20px',
  background:'#fff',
  margin:'5px',
  // minWidth:'80px',
 },
 rejectBtn:{
  border:'2px solid #d12469',
  padding:'4px 8px',
  color:'#d12469',
  fontSize:'10px',
  fontWeight:600,
  borderRadius:'20px',
  background:'#fff',
  margin:'5px',
  // minWidth:'80px',
 },
 approveBtn:{
  border:'2px solid #26AD8D',
  padding:'4px 8px',
  color:'#26AD8D',
  fontSize:'10px',
  fontWeight:600,
  borderRadius:'20px',
  background:'#fff',
  margin:'5px',
  // minWidth:'80px',
 },
  table: {
    minWidth: '310px',
    marginTop: '20px',
    // border: " 1px solid #C5CFD3",
    // border: " 1px solid #e0e0e0",
    '& .switch .MuiButtonBase-root':{
      position:'absolute',
      padding:'9px',
      top:0,
      left:0,
      color:'#fff'
    },
    '& .switch .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked':{
      color:'#1976d2'
    },
    '& td[value~="Process"]': {
      color: '#8ead26',
      '& span': {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: '22px',
        width: '24px',
        marginRight: '8px',
        display: 'inline-block',
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 256 256' width='24px' height='24px' fill-rule='nonzero'%3E%3Cg fill='%238ead26' fill-rule='nonzero' stroke='none' stroke-width='1' stroke-linecap='butt' stroke-linejoin='miter' stroke-miterlimit='10' stroke-dasharray='' stroke-dashoffset='0' font-family='none' font-weight='none' font-size='none' text-anchor='none' style='mix-blend-mode: normal'%3E%3Cg transform='scale(10.66667 10.66667)'%3E%3Cpath d='M12 2c-5.511 0 -10 4.489 -10 10c0 5.511 4.489 10 10 10c5.511 0 10 -4.489 10 -10c0 -5.511 -4.489 -10 -10 -10zM12 4c4.43012 0 8 3.56988 8 8c0 4.43012 -3.56988 8 -8 8c-4.43012 0 -8 -3.56988 -8 -8c0 -4.43012 3.56988 -8 8 -8zM11 6v6.41406l4.29297 4.29297l1.41406 -1.41406l-3.70703 -3.70703v-5.58594z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
      }
    },
    '& td[value~="Failed"]': {
      color: '#d12969',
      '& span': {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: '22px',
        width: '24px',
        marginRight: '8px',
        display: 'inline-block',
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg stroke='%23d12469' fill='currentColor' stroke-width='0' viewBox='0 0 512 512' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z'%3E%3C/path%3E%3Cpath fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z'%3E%3C/path%3E%3Cpath d='M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z'%3E%3C/path%3E%3C/svg%3E\")",
      }
    },
    '& td[value~="Ready"]': {
      color: '#65c4ac',
      '& span': {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: '22px',
        width: '24px',
        marginRight: '8px',
        display: 'inline-block',
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 256 256' width='24px' height='24px' fill-rule='nonzero'%3E%3Cg fill='%2365c4ac' fill-rule='nonzero' stroke='none' stroke-width='1' stroke-linecap='butt' stroke-linejoin='miter' stroke-miterlimit='10' stroke-dasharray='' stroke-dashoffset='0' font-family='none' font-weight='none' font-size='none' text-anchor='none' style='mix-blend-mode: normal'%3E%3Cg transform='scale(10.66667 10.66667)'%3E%3Cpath d='M12 2c-5.511 0 -10 4.489 -10 10c0 5.511 4.489 10 10 10c5.511 0 10 -4.489 10 -10c0 -5.511 -4.489 -10 -10 -10zM12 4c4.43012 0 8 3.56988 8 8c0 4.43012 -3.56988 8 -8 8c-4.43012 0 -8 -3.56988 -8 -8c0 -4.43012 3.56988 -8 8 -8zM11 6v6.41406l4.29297 4.29297l1.41406 -1.41406l-3.70703 -3.70703v-5.58594z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
        // backgroundImage: "url(\"data:image/svg+xml,%3Csvg stroke='%2365c4ac' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24px' height='24px'%3E%3Cpath d='M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z'/%3E%3C/svg%3E\")",
      }
    },
    '& td[value~="REJECTED"]': {
      color: '#d12969',
    },
    '& td[value~="Email not Send"]': {
      color: '#d12969',
    },
    '& td[value~="PENDING"]': {
      color: '#fff',
      '& div': {
        backgroundColor: '#e4921e',
        width: '100px',
        padding: '8px',
        borderRadius: '25px',
        textAlign: 'center',
        cursor: 'pointer',
      }
    },
    '& td[value~="Email send by RSM"]': {
      color: '#54ae8e',
    },
    '& td[value~="COMPLETED"]': {
      color: '#366daa',
    },
    '& td[value~="NEW"]': {
      color: '#366daa',
    },
    '& td[value~="APPROVED"]': {
      color: '#54ae8e',
    },
    '& td': {
      color: '#1e1e1e',
      maxWidth: '500px',
      // border: " 1px solid #C5CFD3",
      border: " 1px solid #e0e0e0",
      wordBreak: 'break-word',
      textAlign: 'left',
      padding: '8px',
      fontSize: '13px',
      fontWeight: '500',
      '& .MuiButtonBase-root': {
        width: '40px',
        height: '40px',
        padding: '0px',
      },
      '& button svg path': {
        fill: rootColor,
      },
      '& button svg': {
        fontSize:'24px'
      },
      '& .invoiceNumber': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding:'0 3px',
        '& svg':{
          fontSize:'18px'
        }
      },
      '& .MuiIconButton-root.Mui-disabled': {
        '& svg path': {
          fill: '#888484'
        },
      }
    },
    '& th': {
      textAlign: 'left',
      padding: '16px 8px',
      // border: " 1px solid #C5CFD3",
      border: " 1px solid #e0e0e0",

    },
    '& table': {
      width:'100%'
    },
    '& thead': {
     position:'sticky',
     top:0,
     zIndex:1
    },
    '& .actionTd': {
      minWidth: '140px',
      // display:'flex'
    },
    '& .MuiTableCell-root.MuiTableCell-head': {
      backgroundColor: '#fafafa',
      color: '#363636',
      fontSize: '12px',
      fontWeight: '600',
      // padding: '15px 10px',
      borderColor: '#eaeaea',
    },

    '& tr:hover': {
      backgroundColor: '#fafafa',
    }
  },
  pagination: {
    '& p': {
      margin: 0,
    },
    '&  .MuiToolbar-root': {
      padding: '10px 8px 10px 16px',
      '& .MuiInputBase-root': {
        borderRadius: '4px',
        border: '1px solid #7e7b7b;'
      },
    }
  },
  Actbtn: {
    width: '80px',
    padding: '5px 10px',
    border: '1px solid #115a92a6',
    color: '#115a92',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
    position: 'relative',
    '& span': {
      fontSize: '24px',
      paddingLeft: '15px',
      position: 'absolute',
      top: '-6px',
    }
  },
  remActbtn: {
    width: '123px',
    padding: '5px 10px',
    border: '1px solid #e80060',
    color: '#e80060',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
    position: 'relative',
  },
  // QrCodePopup:{
  //   position:'relative',
  // },
  qrclose: {
    display: 'flex',
    '& svg': {
      position: 'absolute',
      right: '5px',
      top: '5px',
      color: '#d12469',
      fontSize: '32px',
      '&:hover': {
        boxShadow: '0px 6px 14px rgba(50, 55, 56, 0.4)',
        borderRadius: '25%',
      }
    },
    '& img': {
      margin: '20px',
    },
  },
  previewBox: {
    // padding: '24px',
    width: '300px',
    // border: '1px solid #e5e5e5',
  },
  footer:{
    width: '100%',
    background: '#004c8c',
    padding: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    bottom:'0',
    zIndex:'1',
    '& p':{
      margin:0,
      color:'#fff',
      fontSize:'12px',
      '@media (max-width: 600px)': {
        fontSize:'10px',
      },
    }
  },
  emailMsgHeading:{
    background:'#f2f6fc',
    color:'#162754',
    padding:'0px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems:'center',
    height:'44px',
    position:'sticky',
    top:0,
    '& button':{
      padding:'4px'
    }
  },
  emailTemplate:{
    margin:'0 15px 15px',
    '& label':{
      color: '#444746',
      fontSize: '.875rem',
      textAlign: 'left',
      whiteSpace: 'nowrap',
      marginRight: '10px',
      marginBottom: '0px',

    },
    '& input':{
      border:0,
      outline:0,
      height:'44px',
      width:'100%',
      fontFamily: 'Roboto,Arial,sans-serif',
      lineHeight: '1.25rem',
      fontSize: '.875rem',
      letterSpacing: '.0142857143em',
      fontWeight: 400,
    },
    '& textarea':{
      border:0,
      outline:0,
      minHeight:'144px',
      width:'100%',
      fontFamily: 'Roboto,Arial,sans-serif',
      lineHeight: '1.25rem',
      fontSize: '.875rem',
      letterSpacing: '.0142857143em',
      fontWeight: 400,
      padding:'10px 0px',
    },
    '& .flx':{
      display:'flex',
      justifyContent:'space-between',
      alignItems: 'baseline',
      '& .mailTo':{
        width:'100%',
        display:'flex',
        alignItems: 'baseline',
        // flexWrap: 'wrap',
      },
      '& .ccBtn':{
        // width:'8%'
      }
    },
    '& .bachLabel':{
      border: '1px solid #b6b6b9',
      borderRadius: '20px',
      padding: '4px 10px',
      fontSize: '.875rem',
      fontFamily: 'Roboto,Arial,sans-serif',
      fontWeight: 400,
      lineHeight: '1.25rem',
      letterSpacing: '.0142857143em',
      marginRight: '6px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& svg':{
        marginLeft:'6px'
      }
    },
    '& .subjBord':{
      borderBottom:'1px solid #cfcfcf',
      borderTop:'1px solid #cfcfcf',
    },
    '& .mailBody':{
      // borderBottom:'1px solid #cfcfcf',
      // borderTop:'1px solid #cfcfcf',
      height:'380px',
      overflow:'auto',
      outline:0
    },
    '& .allEmail':{
      height:'44px',
      display: 'flex',
      alignItems: 'center',
    },
    '& .sendBtn':{
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      gap:'10px',
      '& button':{
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        fontSize: "0.875rem",
        lineHeight: 1.75,
        letterSpacing: "0.02857em",
        textTransform: "uppercase",
        minWidth: "64px",
        padding: "6px 16px",
        outline:0,
        border:0
      },
      '& .btnSendMail':{
        color: "#fff",
        backgroundColor: '#1976d2',
        boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: '25px',
        '&:hover':{
          backgroundColor:'#1976d6',
        },
      },
      '& .btnSendCancle':{
        color: "#fff",
        backgroundColor: '#969292',
        boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: '25px',
        '&:hover':{
          backgroundColor:'#969296',
        },
      },
   
    },  
  },
 
  prevw:{
    padding:'10px',
    minWidth:'900px',
    '& .heading':{
      padding:'10px',
      display: 'flex',
      justifyContent: 'space-between',
      '& h4':{
      fontSize: '24px',
      fontWeight: '600',
      color: '#475F7B',
      marginBottom: '0px',
    },
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      right: '0px',
      color: '#d12469',
      fontSize: '32px',
      '&:hover': {
        boxShadow: '0px 6px 14px rgba(50, 55, 56, 0.4)',
        borderRadius: '25%'
      }
    }
    },
    '& .fromBtn':{
      display: 'flex',
      justifyContent: 'flex-end',
      padding:'10px',
      gap:'10px',
      '& .smtbtn':{
        padding: '7px 24px',
        border: 0,
        color: '#fff',
        background: rootColor,
        borderRadius: '4px'
      },
      '& .cnlbtn':{
        padding: '7px 24px',
        border: 0,
        color: '#fff',
        background: '#7f8185',
        borderRadius: '4px'
      }
    },
  }
}));
export default useStyles;
